<template>
  <div class="topHeader">
    <div class="left"> 
      <div class = 'imgLogo' :style = '{backgroundColor:colorBj}'>
        <img class = 'logo'  v-if="loginInfo.platLogo" :src="commenUrl+loginInfo.platLogo" alt="">
      </div>
      <div class = 'xtname'>{{loginInfo.platName}} -- {{ headerTitle }}</div>
    </div>

    <div class="midList">
      <div
        class="midLi"
        :class="selectIndex == menuIndex ? 'active' : ''"
        @click="selectMenu(menuLi, menuIndex)"
        v-for="(menuLi, menuIndex) in menuList"
        :key="menuLi.id"
      >
        <div>{{ menuLi.name }}</div>
        <div class="line_w"></div>
      </div>
    </div>
    <div class="right">
      <!-- <el-dropdown placement="bottom-start">
        <div style = 'margin-right:20px' class="li_item langStyle">{{langArray.find(e=>e.value==locale).label}}</div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item v-for='(langLi,langIndex) in langArray' :key='langIndex' @click='changeLang(langLi.value)'>{{langLi.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown> -->
      <!-- <el-icon :size="20">
        <UserFilled />
      </el-icon> -->
      <div class="pending-task" @click="goPendTask">
        <div class="pending-task-sign">
          <img src="../../assets/images/daibanrenwu.png" alt="">
          <div class="txt">我的待办</div>
        </div>
        <div class="pending-task-num">
          <span>{{ todototal > 99 ? '99+' : todototal }}</span>
        </div>
      </div>
      <div class="serve_online" v-if="isShowChat" @click="goServeOnline">在线客服</div>
      <img class = 'logout' src="../../assets/images/morentx.png" alt="">
      <span class="userName">{{ userName }}</span>
      <img @click="logout" style = 'cursor: pointer;' class = 'logout' src="../../assets/images/logout.png" alt="">
      <!-- <svg @click="logout" alt="退出登录" style="margin-left:10px;margin-top:3px;cursor: pointer;" width="20px" height="15px" viewBox="0 0 20 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>退出</title>
          <g id="页面-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
              <g id="基地管理" transform="translate(-1400.000000, -23.000000)" fill="#000000" fill-rule="nonzero">
                  <g id="退出" transform="translate(1400.000000, 23.000000)">
                      <path fill="currentColor" d="M19.9558826,7.27269985 L14.5133763,10.901122 L14.5133763,8.17977121 L5.4425454,8.17977121 L5.4425454,6.3657066 L14.5133763,6.3657066 L14.5133763,3.64445344 L19.9558826,7.27269985 Z M9.97796083,1.83029117 L1.81420133,1.83029117 L1.81420133,12.7152062 L9.97796083,12.7152062 L9.97796083,9.99395301 L11.7921231,9.99395301 L11.7921231,14.5294661 L9.97796083,14.5294661 L1.81420133,14.5294661 L3.90625455e-05,14.5294661 L3.90625455e-05,12.7152062 L3.90625455e-05,1.83029117 L3.90625455e-05,0.0160312462 L1.81420133,0.0160312462 L9.97796083,0.0160312462 L11.7921231,0.0160312462 L11.7921231,4.55154434 L9.97796083,4.55154434 L9.97796083,1.83029117 L9.97796083,1.83029117 Z" id="形状"></path>
                  </g>
              </g>
          </g>
      </svg> -->
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance, watch,onMounted,computed } from "vue";
import { UserFilled } from "@element-plus/icons-vue";
import { useRouter,useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'
import lang from "@/lang";
import { useStore } from 'vuex';
export default {
  components: { UserFilled, },
  props: {
    index: Number,
    list: Array,
    lang:''
  },
  setup(props, context) {
    const { proxy } = getCurrentInstance();
    const { locale } = useI18n()
    const router = useRouter();
    const route = useRoute()
    const store = useStore();
    const todototal = computed(() => store.getters['todo/totalCount']);
     //获取平台名称和平台logo
     let loginInfo=ref({
      platName:"产业工作台",
      platLogo:"",
    });
    if(localStorage.getItem("platLoginInfo")){
      let platLoginInfo=JSON.parse(localStorage.getItem("platLoginInfo"));
      platLoginInfo.map(item=>{
        if(item.platConfigType=='0'){
          loginInfo.value.platName=item.value;
        }
        if(item.platConfigType=='4'){
          loginInfo.value.platLogo=item.value;
        }
      });
    }

    const headerTitle = ref("");
    const userName = ref("");
    const langArray = ref(lang.language)

    if (proxy.getCookie("userInfoIndustry")) {
      let userInfoIndustry = JSON.parse(proxy.getCookie("userInfoIndustry"))?.user
      if(userInfoIndustry.parentId){
        // 子账户
        userName.value = userInfoIndustry.loginName.split("_")[0];
      }else{
        userName.value = userInfoIndustry.loginName
      }
    }
    const menuList = ref(props.list);
    const selectIndex = ref(props.index);
    const changeLang = (lang) => {
      if(locale.value == lang){
        return
      }
      proxy.setCookie("industryLang", lang);
      location.reload()
    }
    const colorBj = ref('')

    const getherdercolor = () =>{  
      proxy.$request({
            url:'SYSTEM_N_FINDALLPLATCONFIG',
            method: "post",
            data:{
               
            }
        }).then((res)=>{
            console.log(res,222222)
            if(res.data.code=='000'){
              res.data.result.map((item) =>{
                if(item.platConfigType == '26'){
                  colorBj.value = item.value
                }
              })
            }
        }).catch((err)=>{
            console.log(err)
        })
    }
    getherdercolor()
    // 加载客服信息
    let isShowChat=ref(false)//是否显示在线客服入口
    function loadAgentInfo(){
      proxy.$request({
        url:"AGENT_CHATWOOT_INFO",
        method: "post",
      }).then((res)=>{
          console.log('res',res)
        if(res.data.code=="000"){
          if(res.data.result){
            isShowChat.value=true
          }
        }
      }).catch((err)=>{
          console.log(err)
      })
    }
    loadAgentInfo()
    onMounted(() => {
      
      if(!route.query.ltype){
          headerTitle.value = ''
        }else{
          if(proxy.getCookie("menuList")){
            let menuListM = JSON.parse(proxy.getCookie("menuList"))||[]
            let menuLi = menuListM.find(e=>route.query.ltype==e.type)
            if(menuLi){
              headerTitle.value = menuLi.name
            }else{
              headerTitle.value = ''
            }
          }else{
            headerTitle.value = ''
          }
        }
        if(route.path!=='/pendTask'){
          store.dispatch('todo/fetchTodoData');
        }
    })
    watch(
      () => props.index,
      (newValue) => {
        selectIndex.value = newValue;
      }
    );
    watch(
      () => props.list,
      (newValue) => {
        menuList.value = newValue;
      }
    );
    const selectId = ref("");
    const selectMenu = (e, index) => {
      selectIndex.value = index;
      selectId.value = e.id;
      context.emit("change", {
        index: selectIndex.value,
        type: menuList.value[selectIndex.value].type,
      });
    };
    // proxy.getCookie("menuList");
    const logout = () => {
      //退出
      proxy
        .$confirm("确定要退出登录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          proxy
          .$request({
            url: "LOGOUT",
            data: {},
          })
          .then((res) => {
            if (res.data.code == "000") {
              proxy.setCookie("userInfoIndustry", "");
              localStorage.setItem("isConfirmAuth","");
              router.push({
                path: "/login",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
        })
        .catch(() => {
        });
    };
    const goServeOnline = ()=>{
      // router.push({
      //   path: "chatIndex",
      //   query:{
      //     ltype:"plat_b2b"
      //   }
      // });
      router.push({
        path: "/workspace",
        query:{
          ltype:"plat_b2b"
        }
      });
    }
    const goPendTask=()=>{
      router.push({
        path: "pendTask",
      });
    }
    return {
      headerTitle,
      userName,
      logout,
      menuList,
      selectIndex,
      selectId,
      selectMenu,
      changeLang,
      locale,
      langArray,
      loginInfo,
      colorBj,
      getherdercolor,
      goServeOnline,
      isShowChat,
      goPendTask,
      todototal
    };
  },
};
</script>

<style scoped lang="less">
.topHeader {
  // padding: 10px 18px;
  height:60px;
  display: flex;
  justify-content: space-between;
  background:#fff;
  box-shadow: 0px 1px 0px 0px #E5E6EB;
  padding-right:20px;

  .left {
    font-size: 20px;
    color: #3f4156;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    .imgLogo{
      width:98px;
      height:60px;
      display: flex;
      justify-content: space-around;
      align-items: center;
     
      .logo{
        width:36px;
        height:36px;
      }
    }
    .xtname{
      line-height:60px;
      margin-left:15px;
    }
  }
  .midList {
    font-size: 16px;
    color: #222222;
    display: flex;
  }
  .right {
    color: #3f4156;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .el-icon {
      margin-left: 25px;
      cursor: pointer;
    }
    .userName {
      margin: 0 20px 0 10px;
    }
    .serve_online{
      margin-right: 20px;
      cursor: pointer;
    }
    .logout{
      width:34px;
      height:34px;
    }
    .pending-task{
        position: relative;
        cursor: pointer;
        margin-right: 20px;
        .pending-task-sign{
          display: flex;
          align-items: center;
          img{
            width: 22px;
            height: 22px;
            margin-right: 10px;
          }
          .txt{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #4E5969;
          }
        }
        .pending-task-num{
          position: absolute;
          top: -5px;
          left: 17px;
          padding: 0 2px;
          height: 10px;
          line-height: 8px;
          background: #FF0000;
          border-radius: 50%;
          span{
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 10px;
            color: #FFFFFF;
          }
        }
      }
  }
  .midLi {
    margin: 0 20px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #222222;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .line_w{
      display: flex;
      margin-top: 4px;
      width: 24px;
      height: 3px;
      background: #fff;
    }
  }
  .active {
    color: #3e7fff;
    .line_w{
      background: #3e7fff;
    }
  }
  .el-dropdown{
    line-height: normal;
  }
  .li_item:focus-visible{
    outline: none;
  }
}
</style>
